let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5mEoX")).then(() => parcelRequire('8JqPQ'));